import { render, staticRenderFns } from "./AddTrackingItemInstance.vue?vue&type=template&id=2b1572ae&scoped=true"
import script from "./AddTrackingItemInstance.vue?vue&type=script&lang=js"
export * from "./AddTrackingItemInstance.vue?vue&type=script&lang=js"
import style0 from "./AddTrackingItemInstance.vue?vue&type=style&index=0&id=2b1572ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1572ae",
  null
  
)

export default component.exports